import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./StoryScreen3.css"
import { ImgStoryScreen2, ImgStoryScreen2b, NewStickerStory } from "../../assets";

const StoryScreen3 = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenStoryScreen3 = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenStoryScreen3.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenStoryScreen3: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenStoryScreen3: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: "",
                alt: ""
            }
        },
        shield: {

        },
        content: {
            left: {
                desc:
                [
                    "But this story begins with heartbreak. I’ve witnessed how mycelium fermentation knowledge and foods like tempeh are both appropriated and erased from their rich cultural history by Swedish startup companies claiming to be sustainable (see my thesis project here, investigating this phenomenon link.",
                    "So, I decided to reclaim the narrative. Kuno was born out of a deep respect for fermentation traditions and a commitment to honoring the origins. We’re not just making food—we’re reviving knowledge, celebrating heritage, and ensuring that the story of tempeh and mycelium fermentation is told by those to whom it truly belongs.",
                    "More than that, in Indonesia food is a love language and sharing & connecting to people through this amazing plant-based food is something that I truly treasure and enjoy. Tempeh carries profound sustainability wisdom—teaching us that if we take care of nature, nature will take care of us. This is a story worth telling, and one that Kuno is here to share."
                ]
                //  [
                //     "Living in Sweden for a year, I started to crave the taste of tempe so much. For the hope of it all thinking that I will find tempe in Swedish supermarket, I stumbled upon two food brands selling tempe under completely different names, making it as if they had discovered some revolutionary vegan innovation. The audacity 😒 I mean… imagine taking Wine or Kimchi and erasing their entire history and heritage.",
                //     "Here they are food companies that pretend they care about planet, greenwashing people who genuinely care about the planet and at the same time profiting off Indonesian food culture and simultaneously erasing our culture, and present themselves as innovative and not telling people this food has at least 500 years history and food heritage behind it. (At this point I think, being and sounding unhinged is earned 😭).",  
                // ]
            },
            right: {
                image: {
                    src: NewStickerStory,
                    alt: ""
                }
            }
        }
    }
    
    return(
        <>
            <div 
            ref={screenStoryScreen3} 
            className={`${windowWidthClass}-story-screen-3 wrapper`}>

                <div className="background">
                    <div className="frame">
                        {/* <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        /> */}
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display grid">
                    <div className="text-wrapper image">
                        <div className="frame">
                            <img 
                                alt=""
                                src={componentData.content.right.image.src}
                            />
                        </div>
                    </div>
                    <div className="text-wrapper text">
                           {componentData.content.left.desc.map((text:any, index:any)=>{
                            return (
                                <p key={index}>{text}</p>
                            )
                           })}
                    </div>
                </div>

            </div>
        </>
        
    )
};

export default StoryScreen3;